import { MapboxClusterData } from '@bringg/react-components/dist/types/maps.consts';
import { get as _get } from 'lodash';
import {
	DEFAULT_CONFIGURATION,
	RoutesPlannerConfiguration,
	RoutesPlannerTimelineConfig
} from '@bringg-frontend/routes-planner';
import { HourFormat } from '@bringg/types';
import { dateUtils } from '@bringg-frontend/utils';

const getRoutesPlannerConfiguration = (configuration: any): RoutesPlannerConfiguration => {
	const DEFAULT_CLUSTER_BELOW_ZOOM = 2;
	const DEFAULT_CLUSTER_RADIUS = 10;
	const DEFAULT_CLUSTER_MIN_POINTS = 10;
	const DEFAULT_SHOULD_CLUSTER = true;

	const DEFAULT_TIMELINE_AXIS_BOUNDARY_BUFFER_HOURS = 3;
	const DEFAULT_TIMELINE_ZOOM_MAX = DEFAULT_CONFIGURATION.timelineConfig.zoomMax;

	const config =
		_get(configuration, ['dashboard_ui_configuration', 'preview_map_configuration', 'routes_planner_config']) || {};

	const clusterConfig: MapboxClusterData = {
		clusterBelowZoom: _get(config, ['cluster_config', 'cluster_below_zoom'], DEFAULT_CLUSTER_BELOW_ZOOM),
		clusterRadius: _get(config, ['cluster_config', 'cluster_radius'], DEFAULT_CLUSTER_RADIUS),
		clusterMinPoints: _get(config, ['cluster_config', 'cluster_min_points'], DEFAULT_CLUSTER_MIN_POINTS),
		shouldCluster: _get(config, ['cluster_config', 'should_cluster'], DEFAULT_SHOULD_CLUSTER)
	};
	const timelineConfig: RoutesPlannerTimelineConfig = {
		axisBoundaryBufferHours: _get(
			config,
			['timeline_config', 'axis_boundary_buffer_hours'],
			DEFAULT_TIMELINE_AXIS_BOUNDARY_BUFFER_HOURS
		),
		zoomMax: _get(config, ['timeline_config', 'zoom_max'], DEFAULT_TIMELINE_ZOOM_MAX),
		canSetTasksPastDeliveryBlock: _get(config, ['timeline_config', 'can_set_tasks_past_delivery_block'], false)
	};

	const handlingUnits = _get(configuration, 'custom_units_definition');

	const enableVehicles = _get(configuration, 'enable_vehicles', false);
	const countryCode = _get(configuration, 'country_code');
	const hourFormat = dateUtils.getMerchantTimeFormat(_get(configuration, 'hour_format', HourFormat.Default));
	const uniqueInventoryFields: string[] = _get(configuration, 'unique_inventory_fields', []);
	const enableTaskPrice = _get(configuration, 'enable_task_price', false);
	const enableSkills = _get(configuration, 'enable_skills', false);
	const dynamicCapacityMode = _get(configuration, 'dynamic_capacity_values_mode');
	const ignoreQuantityInLoadCalculation = _get(configuration, 'ignore_inventory_quantity_for_capacity_calculation');
	const endOfWeekDay = _get(configuration, 'end_of_week_day');
	const ignoreInventoryQuantityForCapacityCalculation = _get(
		configuration,
		'ignore_inventory_quantity_for_capacity_calculation'
	);

	return {
		clusterConfig,
		timelineConfig,
		handlingUnits,
		enableVehicles,
		countryCode,
		hourFormat,
		uniqueInventoryFields,
		enableTaskPrice,
		enableSkills,
		dynamicCapacityMode,
		ignoreQuantityInLoadCalculation,
		endOfWeekDay,
		ignoreInventoryQuantityForCapacityCalculation
	};
};

const MAP_DEFAULT_ZOOM = 12;

export const configurationService = { getRoutesPlannerConfiguration, MAP_DEFAULT_ZOOM };
